import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  display: flex;
  padding: 16px 0 16px 20px;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  align-self: stretch;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.black4};
  font-weight: 600;
`;

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
`;
